import React from 'react';
import Footer from "./Footer";
import '../styles/Disclaimer.css';

const Disclaimer = () => {
  return (
    <>
     <div className="disclaimer-page">
  <div className="disclaimer-container">
    <div className="disclaimer-content">
      <section className="disclaimer-header">
        <h1>⚠️ Disclaimer</h1>
        <p className="update-date">Last updated: March 27, 2025</p>
        <p className="intro-text">
          This website and its content are provided by Silvertidequest AS as a free social entertainment service.
        </p>
      </section>

      <section className="disclaimer-section gaming-section">
        <h2>🎮 No Real Gambling</h2>
        <ul>
          <li><span>💸</span> We do not offer real money gambling</li>
          <li><span>❌</span> You cannot bet or win money or prizes</li>
          <li><span>🆓</span> All games are 100% free to play</li>
          <li><span>🎯</span> All gameplay is for entertainment purposes only</li>
        </ul>
      </section>

      <section className="disclaimer-section legal-section">
        <h2>🧑‍⚖️ Legal Responsibility</h2>
        <p>We do not guarantee:</p>
        <ul>
          <li>The accuracy or completeness of the games</li>
          <li>That playing on this platform leads to winnings in real-money gambling</li>
          <li>Uninterrupted availability or technical error-free operation</li>
        </ul>
        <p className="emphasis">All use is at your own risk.</p>
      </section>

      <section className="disclaimer-section responsible-section">
        <h2>🧠 Play Responsibly</h2>
        <p>
          Although this is not real gambling, we encourage all users to play in moderation and follow the principles of responsible gaming.
        </p>
        <p>
          Need help? Visit{' '}
          <a href="http://www.loketkansspel.nl" target="_blank" rel="noopener noreferrer">
            www.loketkansspel.nl
          </a>
        </p>
      </section>

      <section className="disclaimer-section contact-section">
        <h2>📬 Contact</h2>
        <p>If you have questions regarding this disclaimer:</p>
        <div className="contact-info">
          <p className="company-name">Silvertidequest AS</p>
          <p>
            <span>📧</span>{' '}
            <a href="mailto:Silvertidequest@gmail.com">Silvertidequest@gmail.com</a>
          </p>
          <p>
            <span>📍</span> Assen Drenthe Brink 23,9401 HT Assen,Netherlands
          </p>
        </div>
      </section>
    </div>
  </div>
</div>

      <Footer />
    </>
  );
};

export default Disclaimer;
